// extracted by mini-css-extract-plugin
module.exports = {"LocationIcon":"MapOutput_LocationIcon__EX4ru","CustomMarker":"MapOutput_CustomMarker__t9nZK"};